import React from 'react'

function TenderTextSemi() {
  return (
    <embed src="\pdfs\EAT1.4.2.2_Q-ZH_Semi-circular_displacement_outlet_kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextSemi